const MAX_LENGTH = 100;

export const INVALID_NAME_MESSAGE = 'That name isn’t valid — please check it and try again.';

export function validateName(value: string, label: 'first name' | 'last name'): string | null {
  const trimmed = value.trim();
  if (!trimmed) return `Enter your ${label}`;
  if (trimmed.length > MAX_LENGTH) return `Use ${MAX_LENGTH} characters or fewer`;
  if (/\p{Cc}/u.test(trimmed)) return 'Remove unsupported characters';
  return null;
}
